import { render } from "./Home.vue?vue&type=template&id=45622b12&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=45622b12&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-45622b12"

export default script